module.exports = __webpack_public_path__ + "static/img/1.a726d9ce.png";